import React from 'react';
import { Box } from '@mui/material';
import DownloadApp from './downloadapp';
const Aplicacion = () => (
  <Box id="aplicacion" sx={{ py: 5, px: 2 }}>

        <DownloadApp/>
  </Box>
);

export default Aplicacion;